import Swal from "sweetalert2";
const API_URL = "https://live-chat-api.velormall.com";
const VAPID_PUBLIC_KEY = "BDH7pnlmYikH2qkLTkjZN9AHtCdMfw4OQeWP8l-0l2y0ikB6ILz8nmZHkLPKvVC67QCaSuyQcgfnswzYnxnnyfM";


// =====================================================
// Convert VAPID key
// =====================================================

function urlBase64ToUint8Array(base64String) {

    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);

    const base64 = (base64String + padding)
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    const rawData = window.atob(base64);

    return Uint8Array.from(
        Array.from(rawData).map((char) =>
            char.charCodeAt(0)
        )
    );
}


// =====================================================
// Detect Device
// =====================================================

function getDevice() {

    const userAgent = navigator.userAgent;

    if (/Android|iPhone|iPad|iPod/i.test(userAgent)) {
        return "mobile";
    }

    return "desktop";
}


// =====================================================
// Enable Push
// =====================================================

const enablePush = async (userData) => {

    try {

        // =============================================
        // Service Worker support
        // =============================================

        if (!("serviceWorker" in navigator)) {

            throw new Error(
                "Service Worker is not supported."
            );
        }


        // =============================================
        // Push API support
        // =============================================

        if (!("PushManager" in window)) {

            throw new Error(
                "Push notification is not supported."
            );
        }


        // =============================================
        // Notification support
        // =============================================

        if (!("Notification" in window)) {

            throw new Error(
                "Notification API is not supported."
            );
        }


        // =============================================
        // HTTPS
        // =============================================

        if (!window.isSecureContext) {

            throw new Error(
                "Push notification requires HTTPS."
            );
        }


        // =============================================
        // Permission
        // =============================================

        // console.log("Current permission:", Notification.permission);


        if (Notification.permission === "denied") {

            throw new Error(
                "Notifications are blocked. Please allow notifications from Chrome Site Settings."
            );
        }


        const permission = await Notification.requestPermission();


        // console.log("Permission:", permission);


        if (permission !== "granted") {

            throw new Error(
                "Notification permission denied."
            );
        }


        // =============================================
        // Register Service Worker
        // =============================================

        const registration =
            await navigator.serviceWorker.register(
                "/push-sw.js",
                {
                    scope: "/",
                }
            );


        // console.log("Service Worker registered:", registration);


        // =============================================
        // Wait for Service Worker
        // =============================================

        const readyRegistration =
            await navigator.serviceWorker.ready;


        // console.log("Service Worker ready:", readyRegistration);


        // =============================================
        // VAPID key
        // =============================================

        const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);


        if (applicationServerKey.length !== 65) {

            throw new Error(
                "Invalid VAPID public key."
            );
        }


        // =============================================
        // Existing subscription
        // =============================================

        let subscription = await readyRegistration.pushManager.getSubscription();


        // console.log("Existing subscription:", subscription);


        // =============================================
        // Create subscription
        // =============================================

        if (!subscription) {

            // console.log("Creating new subscription...");


            subscription = await readyRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey,
            });


            // console.log("New subscription:", subscription);
        }


        // =============================================
        // Subscription JSON
        // =============================================

        const subscriptionJSON = subscription.toJSON();


        // console.log("Subscription JSON:", subscriptionJSON);


        // =============================================
        // Device
        // =============================================

        const device = getDevice();


        // =============================================
        // Backend data
        // =============================================

        const sentData = {
            ...userData,
            subscription: subscriptionJSON,
            device,
            browser: navigator.userAgent,
        };


        // console.log("Sending subscription:", sentData);


        // =============================================
        // Save Backend
        // =============================================

        const response =
            await fetch(
                `${API_URL}/api/push/admin/subscribe`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type":
                            "application/json",
                    },

                    body:
                        JSON.stringify(
                            sentData
                        ),
                }
            );


        if (!response.ok) {
            throw new Error(
                `Subscription save failed: ${response.status}`
            );
        }


        const data = await response.json();


        // console.log("Backend response:", data);


        if (!data.success) {
            throw new Error(
                data.message ||
                "Subscription failed."
            );
        }


        return {
            success: true,
            data,
        };

    } catch (error) {

        // console.error("Push Error:", error);
        throw error;
    }
};


// =====================================================
// SweetAlert
// =====================================================

export const AdminNotificationsAlert =
    async (userData) => {

        // =============================================
        // Confirmation
        // =============================================

        const result =
            await Swal.fire({

                title: "Enable Notifications?",
                text: "You will receive new message notifications.",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, Enable",
                cancelButtonText: "Cancel",
                reverseButtons: false,
                customClass: {
                    confirmButton: "btn btn-success me-2",
                    cancelButton: "btn btn-danger",
                },

                buttonsStyling: false,
            });


        // =============================================
        // Cancel
        // =============================================

        if (!result.isConfirmed) {
            return {
                success: false,
                cancelled: true,
            };
        }


        // =============================================
        // Loading
        // =============================================

        Swal.fire({

            title: "Enabling Notification...",
            text: "Please wait while we enable notifications.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });


        try {

            // =========================================
            // Enable Push
            // =========================================

            const result =
                await enablePush(
                    userData
                );


            // =========================================
            // Success
            // =========================================

            await Swal.fire({
                icon: "success",
                title: "Enabled!",
                text: "Push notification enabled successfully.",
                confirmButtonText: "OK",
            });


            return result;

        } catch (error) {

            // console.error("Notification Error:", error);


            // =========================================
            // Error
            // =========================================

            await Swal.fire({
                icon: "error",
                title: "Notification Error",
                text: error?.message || "Failed to enable notification.",
                confirmButtonText: "OK",
            });


            return {
                success: false,
                error: error?.message,
            };
        }
    };
